var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMarkerVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.91429 5.4902C3.70286 7.08497 4.81714 8 6 8C7.18286 8 8.29714 7.08497 9.08571 5.4902L11.6571 0.261439C11.7429 0.104576 11.8629 0 12 0H0C0.0857143 0.0261438 0.291428 0.156864 0.342857 0.261439L2.91429 5.4902Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMarkerVector);
export default __webpack_public_path__ + "static/media/icon-marker-vector.d5942a5622ae93435a3e05389b698f47.svg";
export { ForwardRef as ReactComponent };